import { requestStateData } from './requestStateData'
import { useStateData } from './useStateData'
import { SignupState } from '../types'

export const fetchPrinterOffer = () =>
  requestStateData(
    'printerOffer',
    ({
      signupSession: {
        instantInkService,
        printerSku,
        printerSerialNumber,
        printerBizModel,
        supplyTypes
      },
      localization,
      isLoggedIn,
      partialSubscription
    }: SignupState) =>
      instantInkService.fetchPrinterOffer({
        serialNumber: printerSerialNumber || '',
        productNumber: printerSku || '',
        bizModel: printerBizModel || 'Flex',
        supplyTypes: supplyTypes || '',
        createStandardOobeRegistration: true,
        country: localization.country,
        language: localization.language,
        flow: 'oobe',
        partialSubscriptionId: isLoggedIn
          ? partialSubscription?.data?.id
          : undefined
      })
  )

export const usePrinterOffer = () =>
  useStateData('printerOffer', fetchPrinterOffer, () => true)
